import React, { Component, ErrorInfo } from 'react'
import { WrapperProps } from '..'
import { UNKNOWN_ERROR_CONTENT } from './constants'
import { MaybeErrorData } from './types/errorTypes'

interface ErrorBoundaryState {
  errorData: MaybeErrorData
}

const clearedState: ErrorBoundaryState = {
  errorData: undefined
}

export class ErrorBoundary extends Component<
  React.PropsWithRef<React.PropsWithChildren<WrapperProps>>,
  ErrorBoundaryState
> {
  public state: ErrorBoundaryState = clearedState

  public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI.
    return { errorData: { error: error } }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // console.error('Uncaught error:', error, errorInfo)
    this.setState({
      errorData: { error, errorInfo }
    })
  }

  public render() {
    const { errorHeader, errorText } = UNKNOWN_ERROR_CONTENT
    return this.state.errorData ? (
      <>
        <h1>{errorHeader}</h1>
        {errorText}
      </>
    ) : (
      this.props.children
    )
  }
}
